import React from 'react';
import Section from './section';
import ModalsContextProvider from '../context/modals';
import '../fragments/sections';

const Sections = ({ sections }) => (
  <ModalsContextProvider>
    {sections.filter(Boolean).map((section) => (
      <Section
        key={section.id}
        {...section}
      />
    ))}
  </ModalsContextProvider>
);

export default Sections;
